import React from "react";
import { Button, Form, Input, Select } from "antd";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
const ContactForm = (props) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    props.onFinish(values);
  };

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{
          width: 70,
        }}
      >
        {props.phoneNumberPrefixes.map((item) => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  return (
    <div>
      <h2>Add Contact Information</h2>
      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={onFinish}
        initialValues={{
          prefix: "",
        }}
        // scrollToFirstError
      >
        <Form.Item
          name="contactPerson"
          label="Contact Person"
          rules={[
            {
              required: true,
              message: "Please enter your contact person!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[
            {
              required: true,
              message: "Please enter your phone number!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            addonBefore={prefixSelector}
            style={{
              width: "100%",
            }}
          />
        </Form.Item>
        <Form.Item
          name="alternativeNumber"
          label="Alternative Phone Number"
          rules={[
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            addonBefore={prefixSelector}
            style={{
              width: "100%",
            }}
          />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter your email !",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="designation"
          label="Designation"
          rules={[
            {
              // required: true,
              message: "Please enter your designation!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            ok
          </Button>
          <Button
            type="default"
            onClick={() => {
              props.setmodalContent("");
            }}
            style={{
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ContactForm;
